import * as ScholarshipCategoryStoreActions from './scholarshipcategory.actions';
import * as ScholarshipCategoryStoreSelectors from './scholarshipcategory.selectors';
import * as ScholarshipCategoryStoreReducer from './scholarshipcategory.reducer';

export { ScholarshipCategoryStoreActions, ScholarshipCategoryStoreSelectors, ScholarshipCategoryStoreReducer };
